import { render, staticRenderFns } from "./DeactivateTwoFaDialog.vue?vue&type=template&id=5d255112&scoped=true"
import script from "./DeactivateTwoFaDialog.vue?vue&type=script&lang=js"
export * from "./DeactivateTwoFaDialog.vue?vue&type=script&lang=js"
import style0 from "./DeactivateTwoFaDialog.vue?vue&type=style&index=0&id=5d255112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d255112",
  null
  
)

export default component.exports